import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "We Care Like Family",
    body: "Quick Maid Services Pune was built on a simple belief — your home deserves people you can trust. We treat every household with the warmth, respect and attention we'd give our own family.",
  },
  {
    n: "02",
    title: "Vetted, trained, dependable",
    body: "Every maid, cook, nanny and caretaker is background-verified and trained before they ever step into your home. Reliability isn't a promise — it's our standard.",
  },
  {
    n: "03",
    title: "Spotless results, every time",
    body: "Quick service, spotless results. From daily help to specialised Japa and elder care, we match the right professional to your exact needs, right here in Pune.",
  },
];

export default function About() {
  return (
    <section id="about" className="py-24 md:py-32 bg-[var(--paper-2)]" data-testid="about">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <p className="label-caps text-[var(--gold)] mb-4">The Quick Maid Promise</p>
        <h2 className="font-display text-4xl md:text-6xl text-[var(--navy)] tracking-tighter max-w-3xl leading-[1.02]">
          Professional care for your home &amp; family.
        </h2>

        <div className="mt-16 space-y-2">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="grid md:grid-cols-12 gap-4 md:gap-8 items-start py-10 border-t border-slate-300 pl-2 md:pl-12"
              data-testid={`chapter-${c.n}`}
            >
              <div className="md:col-span-2">
                <span className="font-display text-5xl md:text-6xl text-[var(--gold)]">
                  {c.n}
                </span>
              </div>
              <h3 className="md:col-span-4 font-display text-2xl md:text-3xl text-[var(--navy)] tracking-tight">
                {c.title}
              </h3>
              <p className="md:col-span-6 text-lg text-slate-600 leading-relaxed">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
